module.exports = __webpack_public_path__ + "img/direction.bf834f9f.png";